/* Gadedly: WhatsApp booking button on spare-part product cards (moved out of snippets/product-card-1.liquid so it is downloaded once instead of being repeated inside every card). */
// استخدام Event Delegation لضمان عمل الزرار في أي سلايدر أو قسم منسوخ بشكل سريع جداً
if (!window.gdWaGlobalInit) {
  window.gdWaGlobalInit = true; 

  document.addEventListener('click', function(e) {
    // 1. التأكد إن الدوسة كانت على زرار الواتساب
    var openBtn = e.target.closest('[data-gd-wa-direct-open]');
    if (!openBtn) return; 

    e.preventDefault(); 

    // 2. البحث عن كارت المنتج الخاص بالزرار
    var root = openBtn.closest('[data-gd-card-root]');
    if (!root) return;

    var variantInput   = root.querySelector('input[name="id"]');
    var variantsScript = root.querySelector('[data-gd-variants-json-card]');

    // 3. جلب البيانات الأساسية
    var isRTL        = openBtn.getAttribute('data-is-rtl') === 'true';
    var waNumber     = openBtn.getAttribute('data-wa-number') || '';
    var productTitle = openBtn.getAttribute('data-product-title') || document.title;
    var logEndpoint  = (openBtn.getAttribute('data-gd-order-endpoint') || '').trim();
    var productUrl   = openBtn.getAttribute('data-product-url') || window.location.href;

    // 4. تحليل بيانات الأنواع (Variants)
    var variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent || '[]') : [];
    } catch(err) {}

    var productId = root.getAttribute('data-product-id') || productTitle;
    var ORDER_KEY = 'gd_wa_order_uid_card_' + productId;

    function generateOrderId(){
      var randStr = Math.floor(Math.random() * 100).toString().padStart(2, '0');
      return '#' + String(Date.now() % 1000000).padStart(6, '0') + randStr;
    }

    function ensureOrderId(){
      try {
        var existing = sessionStorage.getItem(ORDER_KEY);
        if(existing && /^#\d+$/.test(existing)) return existing;
        var id = generateOrderId();
        sessionStorage.setItem(ORDER_KEY, id);
        return id;
      } catch(err) {
        return generateOrderId();
      }
    }

    function clearOrderId(){
      try { sessionStorage.removeItem(ORDER_KEY); } catch(err){}
    }

    function getSelectedVariant(){
      try {
        var currentId = variantInput && variantInput.value ? Number(variantInput.value) : null;
        if(currentId){
          for(var i=0; i < variants.length; i++) {
            if(Number(variants[i].id) === currentId) return variants[i];
          }
        }
      } catch(err){}
      return variants[0] || null;
    }

    function sendLog(payload){
      if(!logEndpoint) return;
      try {
        var body = new URLSearchParams(payload).toString();
        if(navigator.sendBeacon){
          var ok = navigator.sendBeacon(logEndpoint, new Blob([body], { type: 'application/x-www-form-urlencoded' }));
          if(ok) return;
        }
        fetch(logEndpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: body
        }).catch(function(){});
      } catch(err){}
    }

    // 5. تجميع البيانات وتجهيز الرسالة
    var v = getSelectedVariant();
    var orderId = ensureOrderId();
    
    var payload = {
      order_id:      orderId,
      product_title: productTitle || '',
      variant_title: (v && v.title) ? v.title : '',
      variant_id:    (v && v.id) ? String(v.id) : '',
      price:         (v && v.price) ? v.price : '',
      note:          '',
      page_link:     productUrl,
      locale:        (document.documentElement.getAttribute('lang') || '').toLowerCase() || (isRTL ? 'ar' : 'en'),
      user_agent:    navigator.userAgent || '',
      referrer:      document.referrer || ''
    };

    sendLog(payload); 

    var typeTitle = (v && v.title && v.title.toLowerCase() !== 'default title') ? v.title : '';
    var price     = (v && v.price) ? v.price : '';
    var message   = '';

    if(isRTL){
      message = 'محتاج احجز تركيب\nرقم الطلب: ' + orderId + '\nالقطعة المطلوبة: ' + productTitle;
      if(typeTitle) message += '\nالنوع: ' + typeTitle;
      if(price)     message += '\nالسعر: ' + price;
      message += '\nالرابط: ' + productUrl;
    } else {
      message = 'I need to book an installation\nOrder ID: ' + orderId + '\nRequested part: ' + productTitle;
      if(typeTitle) message += '\nType: ' + typeTitle;
      if(price)     message += '\nPrice: ' + price;
      message += '\nLink: ' + productUrl;
    }

    // 6. فتح واتساب
    var url = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(message);
    window.open(url, '_blank', 'noopener');
    clearOrderId();
  });
}
